import {
  Dialog,
  DialogBody,
  DialogSurface,
  Tab,
  TabList,
} from "@fluentui/react-components";
import { DismissFilled } from "@fluentui/react-icons";
import { useEffect, useState } from "react";
import CommissionForm from "./Commission";
import DistributionForm from "../CommissionDistribution/DistributionForm";
import { useLocation } from "react-router-dom";

enum TabValues {
  commission = "tab1",
  distribution = "tab2",
}

// Helper: Convert string prop to TabValues enum
const mapTabStringToEnum = (tab: string | undefined): TabValues => {
  if (tab === "distribution") return TabValues.distribution;
  if (tab === "commission") return TabValues.commission;
  return TabValues.commission; // default
};

const RecieptForm = (props: any) => {
  const location = useLocation();
  const isReceiptingPage = location.pathname === "/commission/receipting";

  const [selectedTab, setSelectedTab] = useState<TabValues>(
    mapTabStringToEnum(props?.tab),
  );

  // Sync when props?.tab changes (e.g. external navigation)
  useEffect(() => {
    if (props?.tab) {
      const newTab = mapTabStringToEnum(props?.tab);
      setSelectedTab(newTab);
    }
  }, [props?.tab]);

  return (
    <Dialog open={props?.receiptEditpopup}>
      <DialogSurface>
        <DialogBody
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0 0 10px",
            }}
          >
            {/* <TabList
              selectedValue={selectedTab}
              onTabSelect={(event, data) => {
                setSelectedTab(data.value as TabValues);
              }}
            >
              {isReceiptingPage ? (
                <Tab value={TabValues.commission}>Commission</Tab>
              ) : (
                <Tab value={TabValues.distribution}>Distribution</Tab>
              )}
            </TabList> */}

            <DismissFilled
              style={{ fontSize: "20px", cursor: "pointer" }}
              onClick={() => {
                props?.setReceiptEditpopup(false);
                props?.setConfirmationPopup(false);
              }}
            />
          </div>

          {/* Content */}
          <div style={{ overflow: "auto", padding: "0 10px" }}>
            {selectedTab === TabValues.commission && (
              <CommissionForm
                setReceiptEditpopup={props?.setReceiptEditpopup}
                getReceiptlistData={props?.getReceiptlistData}
                setStopReceiptpopup={props?.setStopReceiptpopup}
                setSelectedRowIds={props?.setSelectedRowIds}
              />
            )}

            {selectedTab === TabValues.distribution && (
              <DistributionForm
                setStopReceiptpopup={props?.setStopReceiptpopup}
                setReceiptEditpopup={props?.setReceiptEditpopup}
                getReceiptlistData={props?.getReceiptlistData}
                data={props?.data}
                notify={props?.notify}
                open={props?.receiptEditpopup}
                setStopDistributionConfirmationPopup={
                  props.setStopDistributionConfirmationPopup
                }
              />
            )}
          </div>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default RecieptForm;
